import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import * as React from "react";
import TableCell from "@mui/material/TableCell";
import {TableSortLabel} from "@mui/material";
import Box from "@mui/material/Box";
import { visuallyHidden } from '@mui/utils';

export const Thead = ({headers , order, orderBy , onRequestSort, stickyFirstColumn }) => {    
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const getClassName = (h, index) => {
        const baseClass = 'table-cell-head';
        const additionalClass = index === 0 ? 'border-cell-table' : '';
        const widthClass = h.width ? `w-[${h.width}px]` : 'max-w-[200px]'; 
        return `${baseClass} ${additionalClass} ${widthClass}`;
    };
    const isGrouped = headers.length > 0 && headers[0].children !== undefined;

    return (
        <>
    <TableHead className="z-10">
        {isGrouped ? (
            <>
            {/* Ligne 1 : groupes */}
            <TableRow>
                {headers.map((group, idx) => {
                    const visibleChildren = group.children.filter((c) => c.visible);
                    // style spécifique pour la 1ère colonne sticky
                    const stickyStyle =
                        stickyFirstColumn && idx === 0
                            ? {
                                    position: "sticky",
                                    left: 0,
                                    backgroundColor: "inherit",
                                    zIndex: 3, // plus élevé pour être au-dessus des autres cellules
                                    borderRight: "1px solid rgba(224, 224, 224, 1)", // fine bordure droite
                                    boxShadow: "4px 0 6px -4px rgba(0,0,0,0.2)",
                                }
                            : {};
                    return (
                    <TableCell
                        key={idx}
                        align="center"
                        colSpan={group.children.filter((c) => c.visible).length}
                        className={`table-cell-head ${idx === 0 ? "rounded-top-left" : ""}`}
                        sx={{color: "white !important",
                            borderRight: idx !== headers.length - 1 ? "1px solid #fff" : undefined,
                            ...stickyStyle
                        }}
                    >
                        {visibleChildren.length > 1 ? group.group : ""}
                    </TableCell>
                )})}
            </TableRow>

            {/* Ligne 2 : colonnes enfants */}
            <TableRow>
                {headers.map((group, gIdx) =>
                    group.children
                        .filter((h) => h.visible)
                        .map((h, cIdx) => {
                        const isGlobalFirstChild = gIdx === 0 && cIdx === 0; // toute première colonne enfants du tableau
                        const stickyStyle =
                        stickyFirstColumn && gIdx === 0
                            ? {
                                    position: "sticky",
                                    left: 0,
                                    backgroundColor: "inherit",
                                    zIndex: 3, // plus élevé pour être au-dessus des autres cellules
                                    borderRight: "1px solid rgba(224, 224, 224, 1)", // fine bordure droite
                                    boxShadow: "4px 0 6px -4px rgba(0,0,0,0.2)",
                                }
                            : {};
                        return (
                            <TableCell
                                align="left"
                                key={`${gIdx}-${h.key}`}
                                sx={{
                                    minWidth: 60,
                                    borderRight: cIdx === group.children.filter((c) => c.visible).length - 1 
                                        ? "1px solid #fff" 
                                        : undefined,
                                    ...stickyStyle
                                }}
                                className={`table-cell-head ${isGlobalFirstChild ? "rounded-bottom-left" : ""}`}
                            >
                                {h.type !== "action" ? (
                                    <TableSortLabel
                                        active={orderBy === h.key}
                                        direction={orderBy === h.key ? order : "asc"}
                                        onClick={createSortHandler(h.key)}
                                        sx={{
                                            "&.MuiTableSortLabel-root": { color: "white" },
                                            "&.MuiTableSortLabel-root:hover": { color: "white" },
                                            "&.Mui-active": { color: "white" },
                                            "& .MuiTableSortLabel-icon": {
                                            color: "white !important",
                                            fontSize: "15px",
                                            },
                                        }}
                                        >
                                        {h.label}
                                        {orderBy === h.key && (
                                            <Box component="span" sx={visuallyHidden}>
                                            {order === "desc"
                                                ? "sorted descending"
                                                : "sorted ascending"}
                                            </Box>
                                        )}
                                    </TableSortLabel>
                                ) : (
                                    <span className="text-global-white">{h.label}</span>
                                )}
                            </TableCell>
                        );
                    })
                )}
            </TableRow>
            </>
        ) : (
            /* 🟢 Cas simple : headers plats */
            <TableRow hover>
            {headers.map(
                (h, index) =>
                h.visible && (
                    <TableCell
                        align="left"
                        key={index}
                        sx={{ minWidth: 60 }}
                        className={getClassName(h,index)}
                    >
                    {h.type !== "action" ? (
                        <TableSortLabel
                            active={orderBy === h.key}
                            direction={orderBy === h.key ? order : "asc"}
                            onClick={createSortHandler(h.key)}
                            sx={{
                                "&.MuiTableSortLabel-root": { color: "white" },
                                "&.MuiTableSortLabel-root:hover": { color: "white" },
                                "&.Mui-active": { color: "white" },
                                "& .MuiTableSortLabel-icon": {
                                    color: "white !important",
                                    fontSize: "15px",
                                },
                            }}
                        >
                        {h.label}
                        {orderBy === h.key && (
                            <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                    ? "sorted descending"
                                    : "sorted ascending"}
                            </Box>
                        )}
                        </TableSortLabel>
                    ) : (
                        <span className="text-global-white">{h.label}</span>
                    )}
                    </TableCell>
                )
            )}
            </TableRow>
        )}
    </TableHead>
    
    </>)
}